export default function SkewedImage(props) {
	return <div className="skewed">
		<div className="inner">
			<img alt={props.alt} src={props.src} />
		</div>
	</div>
}